<template>
  <div v-if="institution" class="payment-services-statement">
    Payment Services provided by
    <a :href="institution.url" target="_blank" rel="noopener noreferrer">{{
      institution.name
    }}</a
    >, {{ licenceTypeWithArticle }}, company number
    {{ institution.companyNumber }}.
  </div>
</template>
<script>
import {
  getFinancialInstitution,
  withIndefiniteArticle,
} from "src/financialInstitutions";

export default {
  name: "payment-services-statement",
  computed: {
    submerchant() {
      return this.$store.state.submerchant;
    },
    institution() {
      if (!this.submerchant) {
        return null;
      }

      return getFinancialInstitution(
        this.submerchant.financialInstitutionLicence
      );
    },
    licenceTypeWithArticle() {
      if (!this.institution) {
        return null;
      }

      return withIndefiniteArticle(this.institution.licenceType);
    },
  },
};
</script>
<style></style>
